import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { routes } from 'router';
import { ToastMessageQueue } from 'components';
import { CompareOutlet } from 'outlets';
import {
  ApplicationFailed,
  Quotes,
  QuotesUnavailable,
  PersonalDetails,
  ReportIssue,
  ReportIssueSent,
  Request,
  Suggestions,
  SuggestionsSent,
  TechnicalError,
  ThankYou,
} from 'pages';

export const Router = () => (
  <TechnicalError>
    <BrowserRouter>
      <Routes>
        <Route path={routes.compare} element={<CompareOutlet />}>
          <Route path={routes.loanRequest} element={<Request />} />
          <Route path={routes.personalDetails} element={<PersonalDetails />} />
          <Route path={routes.offers} element={<Quotes />} />
          <Route path={routes.offersUnavailable} element={<QuotesUnavailable />} />
        </Route>

        <Route path={routes.suggestions} element={<Suggestions />} />
        <Route path={routes.suggestionsSent} element={<SuggestionsSent />} />
        <Route path={routes.thankYou} element={<ThankYou />} />
        <Route path={routes.reportIssue} element={<ReportIssue />} />
        <Route path={routes.issueSent} element={<ReportIssueSent />} />
        <Route path={routes.appFailed} element={<ApplicationFailed />} />

        <Route path='*' element={<Navigate to={routes.loanRequest} replace />} />
      </Routes>
    </BrowserRouter>

    <ToastMessageQueue />
  </TechnicalError>
);
